import { render, staticRenderFns } from "./GYOrdersShow.vue?vue&type=template&id=0778f18e&scoped=true"
import script from "./GYOrdersShow.vue?vue&type=script&lang=js"
export * from "./GYOrdersShow.vue?vue&type=script&lang=js"
import style0 from "./GYOrdersShow.vue?vue&type=style&index=0&id=0778f18e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0778f18e",
  null
  
)

export default component.exports